import { CartResponseLineItemType } from '../../../apis/src/cart/types';

export const spendAndSavePrefix = 'CART#';

export const toBasketSerialString = (lineItems: Array<CartResponseLineItemType>) => {
  return lineItems
    .filter(item => item.LineTotalDiscountInc > 0)
    .map(item => {
      const itemPromotions = item.Promotions.map(promotion => {
        return promotion.DiscountInc > 0 ? promotion.Name : null;
      });
      return [
        item.SKU,
        item.Quantity ? item.Quantity.toString() : 1,
        Math.round(item.LineTotalDiscountInc * 100).toString(),
        item.Promotions ? itemPromotions.join('; ') : '',
        item.Id ?? '',
      ].join('|');
    })
    .filter(item => item)
    .join('|');
};
